import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = ["action", "id"]
const _hoisted_2 = { class: "form-group position-relative" }
const _hoisted_3 = { class: "row no-gutters g-0" }
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = { class: "form-element" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Zurücksetzen", -1)
const _hoisted_7 = { class: "col-2 d-flex align-items-center justify-content-center" }
const _hoisted_8 = {
  type: "submit",
  class: "btn btn-icon comments-form-btn"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Kommentar verfassen", -1)
const _hoisted_10 = { class: "error" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Schließen", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close = _resolveComponent("close")!
  const _component_comment_arrow = _resolveComponent("comment-arrow")!

  return (_openBlock(), _createElementBlock("form", {
    action: _ctx.formOptions.mainActionUri,
    enctype: "multipart/form-data",
    method: "POST",
    name: "NewsItemCommentForm",
    class: "comments-form",
    id: 'news-item-comment-form-' + _ctx.formOptions.newsUid,
    ref: "commentForm"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("textarea", {
              name: "comment[text]",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.textArea = $event)),
              ref: "commentFormTextArea",
              placeholder: "Kommentar verfassen..."
            }, null, 512), [
              [_vModelText, _ctx.textArea]
            ]),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_ctx.formOptions.isReset || _ctx.isReset)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-icon comments-form-btn-reset",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"]))
                    }, [
                      _createVNode(_component_close),
                      _hoisted_6
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", _hoisted_8, [
            _createVNode(_component_comment_arrow),
            _hoisted_9
          ])
        ])
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("span", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.errorMessage) + " ", 1),
            _createElementVNode("button", {
              class: "btn error-close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isError = false))
            }, [
              _createVNode(_component_close),
              _hoisted_11
            ])
          ], 512), [
            [_vShow, _ctx.isError]
          ])
        ]),
        _: 1
      })
    ]),
    (_ctx.formOptions.eventType === 'addMainComment' && _ctx.formOptions.newsUid)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "hidden",
          name: "comment[page]",
          value: _ctx.formOptions.newsUid
        }, null, 8, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.formOptions.eventType === 'addSubComment' && _ctx.formOptions.commentUid)
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "hidden",
          name: "comment[parentComment]",
          value: _ctx.formOptions.commentUid
        }, null, 8, _hoisted_13))
      : _createCommentVNode("", true),
    (_ctx.formOptions.eventType === 'editComment' && _ctx.formOptions.commentUid)
      ? (_openBlock(), _createElementBlock("input", {
          key: 2,
          type: "hidden",
          name: "comment[__identity]",
          value: _ctx.formOptions.commentUid
        }, null, 8, _hoisted_14))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}